import { Injectable } from '@angular/core';
import { ITypedResponse } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IDeviceInformation, IDeviceNode } from '../shared/models/device';

@Injectable({
    providedIn: 'root'
})
export class CurrentInfoService {
    public static $name = 'currentInfoService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getCurrentInformation(hardwareItemId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getCurrentInformation',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<IDeviceNode>();
    }

    public updateCurrentInformation(device: IDeviceInformation, hardwareItemId: number): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'updateCurrentInformation',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<ITypedResponse<string>>().then((response: ITypedResponse<string>) => {
            return response;
        });
    }

    public saveCurrentInformationTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'saveCurrentInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template,
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<any>().then((response: any) => {
            return response;
        });
    }

    public previewCurrentInformationTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'previewCurrentInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template,
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel>();
    }

    

    public getCurrentInformationTemplates(hardwareItemId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getCurrentInformationTemplates',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public applyCurrentInformationTemplate(device: IDeviceInformation, hardwareItemId: number, templateId: string): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'applyCurrentInformationTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateId: templateId
            }
        }).as<IDeviceNode>();
    }

    public importCaalToCurrentInformation(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'importCaalToCurrentInformation',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<IDeviceNode>();
    }

    public exportCurrentInformationToCaal(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'exportCurrentInformationToCaal',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<number>().then((response: number) => {
            return response;
        });
    }


    public getCanManageTemplates(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getCanUseCurrentInformationTemplates'
        }).as<boolean>();
    }


    public getIsCommissionerModelSupported(device: IDeviceInformation): angular.IPromise<boolean> {
        const identifier = device.$deviceHierarchy.identifier;
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'isCommissionerModelSupported',
            queryParams: {
                'viewModelIdentifier.actorType': identifier.actorType,
                'viewModelIdentifier.entityId': identifier.entityId,
                'viewModelIdentifier.entityType': identifier.entityType,
                'viewModelIdentifier.viewModelType': identifier.viewModelType,
            }
        }
        ).as<boolean>();
    }

}
